import { render, staticRenderFns } from "./promotion-package.vue?vue&type=template&id=2b279e08&"
import script from "./promotion-package.vue?vue&type=script&lang=js&"
export * from "./promotion-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports